import React from "react"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { FormattedMessage } from "react-intl"
import { Box, Typography } from "@carrotfertility/carotene-core"

export const CarrotExpertsModule = () => (
  <Box
    padding={(theme) => theme.tokens.spacing.lg}
    spacing={(theme) => theme.tokens.spacing.lg}
    sx={(theme) => ({
      borderRadius: theme.tokens.borderRadius.md,
      backgroundColor: theme.palette.background.default
    })}
  >
    <RRIconBar iconName="icn-help" iconBackgroundColor="white" />
    <Typography variant="body2" color={(theme) => theme.palette.text.secondary}>
      <FormattedMessage defaultMessage="Carrot resources are for informational purposes only and do not constitute medical advice or professional services. They are not a substitute for legal, tax, or professional medical advice, diagnosis, or treatment. If you are experiencing a medical emergency, call emergency services immediately." />
    </Typography>
  </Box>
)
